export class User {
  id: number;
  username: string;
  password: string;
  name: string;
  lastName: string;
  email: string;
  roles: string[] = [];
  secret: string;
  amount: string;
  term: string;
  recaptchaToken: string;
  recaptchaOrigin: string;
  nuevaSolicitud: boolean;
  allianceCode: string;
  idInfoAlliance: string;
}
